"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "checkPermission", {
  enumerable: true,
  get: function get() {
    return _webPushNotifications.checkPermission;
  }
});
Object.defineProperty(exports, "registerWebPush", {
  enumerable: true,
  get: function get() {
    return _webPushNotifications.registerWebPush;
  }
});
Object.defineProperty(exports, "reregisterWebPush", {
  enumerable: true,
  get: function get() {
    return _webPushNotifications.reregisterWebPush;
  }
});
Object.defineProperty(exports, "supportsWebPush", {
  enumerable: true,
  get: function get() {
    return _webPushNotifications.supportsWebPush;
  }
});
Object.defineProperty(exports, "unregisterWebPush", {
  enumerable: true,
  get: function get() {
    return _webPushNotifications.unregisterWebPush;
  }
});
var _webPushNotifications = require("./web-push-notifications");
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJfd2ViUHVzaE5vdGlmaWNhdGlvbnMiLCJyZXF1aXJlIl0sInNvdXJjZXMiOlsiLi4vLi4vc3JjL3dlYi1wdXNoLW5vdGlmaWNhdGlvbnMvaW5kZXgudHN4Il0sInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7XG4gIGNoZWNrUGVybWlzc2lvbixcbiAgcmVnaXN0ZXJXZWJQdXNoLFxuICByZXJlZ2lzdGVyV2ViUHVzaCxcbiAgc3VwcG9ydHNXZWJQdXNoLFxuICB1bnJlZ2lzdGVyV2ViUHVzaCxcbn0gZnJvbSAnLi93ZWItcHVzaC1ub3RpZmljYXRpb25zJztcblxuZXhwb3J0IHtcbiAgY2hlY2tQZXJtaXNzaW9uLFxuICByZWdpc3RlcldlYlB1c2gsXG4gIHJlcmVnaXN0ZXJXZWJQdXNoLFxuICBzdXBwb3J0c1dlYlB1c2gsXG4gIHVucmVnaXN0ZXJXZWJQdXNoLFxufTtcbiJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7QUFBQSxJQUFBQSxxQkFBQSxHQUFBQyxPQUFBIn0=